var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlugAndSocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 165,
    viewBox: "0 0 330 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.75 0C81.6929 0 46.9865 31.5109 41.8942 72.1875H0V92.8125H41.8949C46.9865 133.489 81.6922 165 123.75 165H134.062C139.776 165 144.375 160.401 144.375 154.688V134.062H175.312V113.438H144.375V51.5625H175.312V30.9375H144.375V10.3125C144.375 4.59937 139.776 0 134.062 0H123.75ZM268.125 0C262.412 0 257.812 4.59937 257.812 10.3125V30.9375H278.438V51.5625H257.812V113.438H278.438V134.062H257.812V154.688C257.812 160.401 262.412 165 268.125 165H330V0H268.125Z",
    fill: "#5F9FAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugAndSocket);
export default __webpack_public_path__ + "static/media/plug-and-socket.ac966e067072804d6a43c186135ff3fb.svg";
export { ForwardRef as ReactComponent };